import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { chooseOptionsConstant, serviceConstants } from 'src/app/constants/service.constants';
import { DateObject, Document_Upload_File, dropdownsource, REGCONFIG_CONTROL } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { EapSummaryService } from 'src/app/services/eap/eap-summary.service';

@Component({
  selector: 'app-eap-registrations-view-modal',
  templateUrl: './eap-registrations-view-modal.component.html',
  styleUrl: './eap-registrations-view-modal.component.scss',
})
export class EapRegistrationsViewModalComponent implements OnInit {
  @Input() public Content: any;

  orgCode: string;
  orgId: string;
  userType: string;
  heading: string;
  action: Subject<any> = new Subject();
  headin: string;
  recState: boolean;
  formFields;
  chooseoptions = chooseOptionsConstant;
  generalInformationForm = new UntypedFormGroup({});
  recordstatus: string = "New";
  public controlsList: REGCONFIG_CONTROL[] = [];
  advanceSearch;
  selectedRow;
  tempdropsource: dropdownsource;
  sourceitems: dropdownsource[] = [];
  content: any;
  screenid: string;
  selectColumns: number = 4;
  screencode: string;
  ScreenContextCode: string = "";
  errormsg: string = "";
  dynomessage: string = "";
  validationMessage: string = "";
  myDate = new Date();
  yesterday = new Date(this.myDate.setDate(new Date().getDate() + 1));
  year: number = this.myDate.getFullYear() + 25;
  timeout: any;
  IsFormToched: boolean = false;
  IsBlocked: boolean = false;
  permission: string = "";
  tooltipValue: any;
  RegistrationData: any;
  isDateModified: boolean = false;
  Full_Date: DateObject;

  /**
   * Constructor for EapRegistrationsViewModalComponent.
   * @param summaryService Service for EAP summary operations.
   * @param modalRef Reference to the active modal.
   * @param commonService Common service for utility functions.
   * @param datepipe Angular DatePipe for date formatting.
   */
  constructor(
    private summaryService: EapSummaryService,
    public modalRef: NgbActiveModal,
    private commonService: CommonService,
    private datepipe: DatePipe,
  ) {
  }

  /**
   * Angular lifecycle hook. Initializes component state and loads controls.
   */
  ngOnInit() {
    this.orgCode = this.Content.content.ORGCODE;
    this.orgId = this.Content.content.ORGID;
    this.userType = this.Content.content.USERTYPE;
    if (this.Content.heading === 'View' || this.Content.heading === 'Edit') {
      this.getScreensControlslistEdit();
      this.permission = 'view';
    }
    else {
      this.getScreensControlslist();
      this.permission = 'new';
    }
  }

  /**
   * Fetches and processes the list of screen controls for new registration.
   * Populates controlsList and initializes control values and source items.
   */
  getScreensControlslist() {
    this.heading = "New";
    let ModuleId = "5";
    this.summaryService.GetregistrationProgram('api/appuser/GetregistrationProgram?ModuleId=' + ModuleId + "&orgId=" + this.orgId).subscribe(summary => {
      this.controlsList = summary;
      if (this.controlsList != null && this.controlsList.length > 0) {
        for (let i = 0; i < this.controlsList.length; i++) {
          this.controlsList[i].ControlValue = "";
          this.controlsList[i].SourceItems = [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            let optionvalues = this.controlsList[i].GROUP_VALUES_LIST;
            let options = optionvalues;
            this.sourceitems = [];
            if (options != null && options != undefined && options.length > 0) {
              for (let iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];
                  this.sourceitems.push(sourceitems);
                }
              }
              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
            const now = new Date();
            let formd = "";
            formd = this.datepipe.transform(new Date(), 'dd-MMM-yyyy');
            this.controlsList[i].ControlValue = null;
          }
          else {
            this.controlsList[i].ControlValue = "";
          }
        }
      }
    });
  }

  /**
   * Validates all controls and returns a validation message string.
   * @returns {string} Validation message(s) if any, otherwise an empty string.
   */
  public validateControlsMsgs(): string {
    this.validationMessage = "";

    if (this.controlsList != null && this.controlsList.length > 0) {
      for (let i = 0; i < this.controlsList.length; i++) {
        const controlName = "dynmcId" + this.controlsList[i].SERIAL_NO;
        document.getElementById(controlName)?.classList.remove(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
        document.getElementById(controlName)?.classList.add(...["ng-untouched", "ng-valid"]);

        if (this.controlsList[i].CONTROL == "6") {
          let seletedItem = "";
          for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
            if (this.controlsList[i].SourceItems[c].Checked == true) {
              if (seletedItem == "")
                seletedItem = this.controlsList[i].SourceItems[c].value;
              else
                seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
            }
          }
          this.controlsList[i].ControlValue = seletedItem;
          if (this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
            document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
            document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
          }
        }
        else if (this.controlsList[i].CONTROL == "10" && this.controlsList[i].IS_MANDATORY) {
          let SelectedValues = this.controlsList[i].ControlValue;

          if (SelectedValues == null || SelectedValues == undefined || SelectedValues == "") {
            this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";

            document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
            document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
          }
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) //
        {
          this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
          document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
          document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
        }
        else if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].CONTROL != "8" && this.controlsList[i].CONTROL != "9" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined)) {
          let tempVal = this.controlsList[i].ControlValue.trim();
          if (tempVal == "") {
            this.validationMessage += "Please enter " + this.controlsList[i].LABEL + "<br/>";
            document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
            document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
          }
        }
        else if (this.controlsList[i].CONTROL == "4" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) //
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
          document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
        }
        else if (this.controlsList[i].CONTROL == "5" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) //
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
          document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
        }
        else if (this.controlsList[i].CONTROL == "7" && this.controlsList[i].IS_MANDATORY && (this.controlsList[i].ControlValue == "" || this.controlsList[i].ControlValue == null || this.controlsList[i].ControlValue == undefined)) //
        {
          this.validationMessage += "Please select " + this.controlsList[i].LABEL + "<br/>";
          document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
          document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
        }
        else if (this.controlsList[i].CONTROL == "8" && this.controlsList[i].IS_MANDATORY) {

          if (this.controlsList[i].UploadFiles == null || this.controlsList[i].UploadFiles == undefined || this.controlsList[i].UploadFiles.length == 0) {
            this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
            document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
            document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
          }
          else if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined && this.controlsList[i].UploadFiles.length > 0) {
            let fileexits = this.controlsList[i].UploadFiles.filter((f) => {
              return f.Status != 'Delete'
            })[0];
            if (fileexits == undefined || fileexits == null) {
              this.validationMessage += "Please upload " + this.controlsList[i].LABEL + "<br/>";
              document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
              document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
            }
          }
        }
        if ((this.controlsList[i].CONTROL == "1" || this.controlsList[i].CONTROL == "2" || this.controlsList[i].CONTROL == "3" || this.controlsList[i].CONTROL == "11") && this.controlsList[i].IS_MANDATORY && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined) {
          this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.trim();
          if (this.controlsList[i].FIELD_CODE == "EMAIL" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            let isvalid = this.commonService.validateEmail(this.controlsList[i].ControlValue);
            if (!isvalid) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
              document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
            }
          }

          if (this.controlsList[i].FIELD_CODE == "WEBSITE" && this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue != "") {
            const website = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';
            if (!this.controlsList[i].ControlValue.match(website)) {
              this.validationMessage += "Please enter valid " + this.controlsList[i].LABEL + "<br/>";
              document.getElementById(controlName)?.classList.add(...["ng-pristine", "ng-invalid", "ng-touched", "validate-error"]);
              document.getElementById(controlName)?.classList.remove(...["ng-untouched", "ng-valid"]);
            }
          }
        }
      }
    }

    return this.validationMessage;
  }

  /**
   * Handles date selection for a question, updates tracking and date object.
   * @param event The date event (Date object).
   * @param question The question object to update.
   */
  DateSelect(event, question) {
    this.IsFormToched = true;
    this.isDateModified = true;
    this.Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: this.isDateModified
    }
    question.dynamicDateobj = this.Full_Date;
  }

  /**
   * Handles registration submission, validates controls, prepares upload data, and calls API.
   */
  Registration() {
    this.errormsg = "";
    let errormsg = this.validateControlsMsgs();
    //let formData1 = new FormData();
    let uploadData = new FormData();
    if (errormsg.length == 0) {
      if (this.controlsList != null && this.controlsList.length > 0) {
        for (let i = 0; i < this.controlsList.length; i++) {

          if (this.controlsList[i].CONTROL == "6") {
            let seletedItem = "";
            for (let c = 0; c < this.controlsList[i].SourceItems.length; c++) {
              if (this.controlsList[i].SourceItems[c].Checked == true) {
                if (seletedItem == "")
                  seletedItem = this.controlsList[i].SourceItems[c].value;
                else
                  seletedItem = seletedItem + "," + this.controlsList[i].SourceItems[c].value;
              }
            }
            this.controlsList[i].ANSWER = seletedItem;
          }
          else if (this.controlsList[i].CONTROL == "8") {
            if (this.controlsList[i].UploadFiles != null && this.controlsList[i].UploadFiles != undefined) {
              for (let j = 0; j < this.controlsList[i].UploadFiles.length; j++) {
                if (this.controlsList[i].UploadFiles[j].Status == "Add") {
                  uploadData.append(this.controlsList[i].UploadFiles[j].ID, this.controlsList[i].UploadFiles[j].File);
                }
              }
              this.controlsList[i].UploadFiles = this.controlsList[i].UploadFiles;
            }
          }
          else if (this.controlsList[i].CONTROL == "10") {
            let SelectedValues = this.controlsList[i].ControlValue;
            if (SelectedValues != null && SelectedValues != undefined && SelectedValues.length > 0) {
              if (SelectedValues instanceof Array || Array.isArray(SelectedValues))
                this.controlsList[i].ControlValue = SelectedValues.join(",");
            }
            else {
              this.controlsList[i].ControlValue = "";
            }
            this.controlsList[i].SUBFIELDNAME = "";
          }
          else if (this.controlsList[i].CONTROL == "5") {
            let controlanswer = this.controlsList[i].ControlValue;
            if (controlanswer != null && controlanswer != controlanswer != undefined) {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.controlsList[i].ANSWER = formd;
            }
            else {
              this.controlsList[i].ANSWER = controlanswer;
            }
          }
        }

        uploadData.append("ScreenData", JSON.stringify(this.controlsList));
        this.summaryService.FilesInsert("api/appuser/inserteap", uploadData).subscribe((result) => {
          if (result != null && result.Status == 0) {
            this.commonService.SuccessBanner(result.Message);
            this.modalRef.close();
          }
          else {
            for (let i = 0; i < this.controlsList.length; i++) {
              if (this.controlsList[i].CONTROL == "10") {
                if (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue != undefined && this.controlsList[i].ControlValue.length > 0) {
                  this.controlsList[i].ControlValue = this.controlsList[i].ControlValue.split(",");
                }
              }
            }
            this.commonService.ValidationBanner(result.Message);
          }
        });
      }
    }
    else {
      this.commonService.ValidationBanner(errormsg);
    }
  }

  /**
   * Checks if a radio button is checked and updates error message display.
   * @param question The question object to check.
   */
  IsRadioChecked(question: any): void {
    if (question.ControlValue == "" && question.Property.Required) {
      question.Property.TempMessage = question.Property.Message;
      question.Property.ShowMessage = true;
    }
    else {
      question.Property.TempMessage = "";
      question.Property.ShowMessage = false;
    }
  }

  /**
   * Checks if a checkbox is checked and updates error message display.
   * @param propery The property object containing options.
   * @param question The question object.
   */
  IsCheckBoxChecked(propery: any, question: any): void {
    let isError: boolean = false;
    if (propery != undefined && propery != null) {
      for (let iOpt = 0; iOpt < propery.Options.length; iOpt++) {
        if (propery.Options[iOpt].Checked != null && propery.Options[iOpt].Checked) {
          propery.TempMessage = "";
          propery.ShowMessage = false;
          isError = true;
          break;
        }
      }
    }

    if (!isError) {
      propery.TempMessage = propery.Message;
      propery.ShowMessage = true;
    }
    else {
      propery.TempMessage = "";
      propery.ShowMessage = false;
    }
  }

  /**
   * Generates a random 8-character hexadecimal string, optionally formatted with dashes.
   * @param s If true, adds dashes to the output string.
   * @returns {string} The generated string.
   */
  public p8(s: boolean): string {
    let p = (Math.random().toString(16) + "000000000").substring(2, 10);
    return s ? "-" + p.substring(0, 4) + "-" + p.substring(4, 8) : p;
  }

  /**
   * Generates a GUID-like string using p8 helper.
   * @returns {string} The generated GUID-like string.
   */
  CreateGuid(): string {
    return this.p8(false) + this.p8(true) + this.p8(true) + this.p8(false);
  }

  /**
   * Deletes the specified file.
   *
   * If the file has not been previously uploaded (i.e. file.Status == "Add"), the file is removed
   * from the question's list of upload files. If the file has been previously uploaded (i.e. file.Status != "Add"),
   * the file is marked for deletion.
   *
   * @param file - The file to be deleted.
   * @param ques - The question control to which the file belongs.
   */
  DeleteUpload(file, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    let code = file.ID;
    if (file.Status == "Add") {
      ques.UploadFiles = ques.UploadFiles.filter(function (sec) {
        return sec.ID != code;
      }, code);
    }
    else {
      file.Status = "Delete";
    }
  }

  /**
   * Opens the specified file in a new window.
   *
   * Downloads the file identified by the given item and opens it in a new window.
   *
   * @param item - The file to be opened.
   */
  OpenFile(item: Document_Upload_File): void {
    let Url = serviceConstants.apiURL + "api/screen/downloadfile/" + item.ID;
    window.open(Url);
  }

  /**
   * Opens a preview of the specified file.
   *
   * Utilizes the commonService to render a preview
   * of the file identified by the given fileID and fileName.
   *
   * @param fileID - The unique identifier of the file to be previewed.
   * @param fileName - The name of the file to be previewed.
   */
  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  /**
   * Triggered when a user selects a file for upload.
   *
   * Checks the extension and size of the selected files. If the file
   * extension is .exe or the size is greater than 50MB, the user is shown
   * an error message. If the file name already exists, the user is also shown
   * an error message. Otherwise, the selected file is added to the question's
   * list of upload files.
   *
   * @param event - The event object representing the file change event.
   * @param ques - The question control to which the selected file belongs.
   */
  uploadchange(event, ques: REGCONFIG_CONTROL): void {
    this.IsFormToched = true;
    let Isexe = false;
    let Is5oMB = false;

    if (ques.UploadFiles == undefined || ques.UploadFiles == null)
      ques.UploadFiles = [];

    for (let i = 0; i < event.target.files.length; i++) {
      let filename = event.target.files[i].name;
      let ext = filename.match(/\.([^\.]+)$/)[1];
      let filesize = event.target.files[i].size;
      let IsValid = true;

      if (filename != null && (ext == 'exe')) {
        Isexe = true;
      }
      else if (filename != null && ((filesize > 52428800))) {
        Is5oMB = true;
      }

      if (IsValid) {
        let uploadFile = new Document_Upload_File();
        uploadFile.ID = this.CreateGuid();
        uploadFile.DOCUMENT_NAME = event.target.files[i].name;
        uploadFile.File = event.target.files[i];
        uploadFile.Status = "Add";
        let hasValue = ques.UploadFiles.filter(x => x.DOCUMENT_NAME.toLowerCase() == uploadFile.DOCUMENT_NAME.toLowerCase());
        if (hasValue.length > 0) {
          //samefileName = true;
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + " Please update the unique file name");

        } else {
          if (ques.ISALLOWMULTIPLEFILES) {
            ques.UploadFiles.push(uploadFile);
          }
          else {
            ques.UploadFiles = [];
            ques.UploadFiles.push(uploadFile);
          }
        }

      }
    }

    if (Is5oMB && Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details and Accepts maximum file size 50MB");
    }
    else if (Is5oMB) {
      this.commonService.ValidationBanner("Accepts maximum file size 50MB");
    }
    else if (Isexe) {
      this.commonService.ValidationBanner("The system does not support .exe files. Please choose a different file format to save the details")
    }
    else {

    }
  }

  /**
   * Checks if a given filename has an allowed extension.
   *
   * This function utilizes the commonService to determine if the
   * file extension of the provided filename is permitted.
   *
   * @param Filename - The name of the file to check.
   * @returns A boolean indicating whether the file extension is allowed.
   */
  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  /**
   * Updates the question's change tracking and sets tooltip value based on selected controls.
   *
   * This function increments the `NotimesChanged` counter for the given question and marks it as touched.
   * If the `NotimesChanged` counter reaches 2 or more, it sets the component's `IsFormToched` flag to true.
   * After a delay, it updates the `tooltipValue` to display the labels of the selected control values.
   *
   * @param $event The event object associated with the change.
   * @param question The question object containing details about control values and source items.
   */
  changeVal($event, question) {
    question.NotimesChanged = question.NotimesChanged + 1;
    question.IsTouched = true;

    if (question.NotimesChanged >= 2)
      this.IsFormToched = true;

    setTimeout(() => {
      let selectedControls = question.ControlValue;
      if (selectedControls != "" && selectedControls != undefined && selectedControls != null) {
        let controlLabel = question.SourceItems.filter((item) => {
          return selectedControls.indexOf(item.value) > -1;
        })
        let labellist = [];
        controlLabel.forEach((item) => {
          labellist.push(item.label);
        });
        this.tooltipValue = labellist.join(",");
      }
      else {
        this.tooltipValue = "";
      }

    }, 200);
  }

  /**
   * Handler for single on-change event for a control.
   *
   * When a single on-change event occurs, this method sets the component's
   * `IsFormToched` flag to true.
   *
   * @param $event The event object.
   */
  singleonChange($event) {
    this.IsFormToched = true;
  }

  /**
   * Fetches and processes the list of screen controls for editing.
   *
   * This method retrieves registration configured fields data from the server
   * based on the current content ID with the specified module "EAP". It then
   * updates the component's `controlsList` with the fetched data.
   *
   * For each control in the list, it initializes `SourceItems` and processes
   * options for controls with types 4, 6, 7, or 10, populating `sourceitems`
   * with necessary dropdown options. It also handles special cases for controls
   * of type 4 by adding a default "Select" option and for type 6 by marking
   * selected items as checked.
   *
   * Additionally, if a control type is 5, it converts the `ControlValue` to a
   * date and formats it according to the specified `DATEFORMATE`, storing the
   * formatted date in `ANSWER`.
   *
   * The method also checks the transaction code from the response to determine
   * if the form should be blocked.
   */
  getScreensControlslistEdit() {
    this.commonService.getRegistratinConfiguredFiledsData(this.Content.content.id, "EAP").subscribe(summary => {
      this.controlsList = summary["Data"];
      this.IsBlocked = summary["TransactionCode"] == "0" ? true : false;

      if (this.controlsList != null && this.controlsList.length > 0) {
        for (let i = 0; i < this.controlsList.length; i++) {
          this.controlsList[i].SourceItems = [];
          if (this.controlsList[i].CONTROL == "4" || this.controlsList[i].CONTROL == "6" || this.controlsList[i].CONTROL == "7" || this.controlsList[i].CONTROL == "10") {
            let optionvalues = this.controlsList[i].GROUP_VALUES_LIST;

            let options = optionvalues;
            this.sourceitems = [];

            if (options != null && options != undefined && options.length > 0) {
              for (let iOpt = 0; iOpt < options.length; iOpt++) {
                if (options[iOpt] != null && options[iOpt] != "") {
                  let sourceitems = new dropdownsource();
                  sourceitems.label = options[iOpt]["label"];
                  sourceitems.value = options[iOpt]["value"];
                  this.sourceitems.push(sourceitems);
                }
              }
              if (this.controlsList[i].CONTROL == "10") {
                let selectedlist = [];
                this.controlsList[i].ControlValue.split(",").forEach((item) => {
                  selectedlist.push(item);
                });
                this.controlsList[i].ControlValue = selectedlist;
              }

              if (this.controlsList[i].CONTROL == "6") {

                if (this.controlsList[i].ControlValue != null && this.controlsList[i].ControlValue.split(',').length > 1) {
                  this.controlsList[i].ControlValue.split(",").forEach((item) => {
                    let source = this.sourceitems.find(x => x.value == item);
                    source.Checked = true;
                  });
                } else {
                  if (this.controlsList[i].ControlValue != null) {
                    let source = this.sourceitems.find(x => x.value == this.controlsList[i].ControlValue);
                    source.Checked = true;
                  }
                }
              }

              if (this.controlsList[i].CONTROL == "4") {
                let tempList = [];
                let sourceitems1 = new dropdownsource();
                sourceitems1.label = "Select";
                sourceitems1.value = "";
                tempList.push(sourceitems1);
                this.sourceitems = tempList.concat(this.sourceitems);
              }
              this.controlsList[i].SourceItems = this.sourceitems;
            }
          }
          else if (this.controlsList[i].CONTROL == "5") {
            this.controlsList[i].ControlValue = new Date(this.controlsList[i].ControlValue);
            let controlanswer = new Date(this.controlsList[i].ControlValue);
            if (controlanswer != null && controlanswer != controlanswer != undefined && this.controlsList[i].DATEFORMATE == 'DD-MMM-YYYY') {
              let formd = this.datepipe.transform(new Date(controlanswer), 'dd-MMM-yyyy');
              this.controlsList[i].ANSWER = formd;
            }
          }
          else {
            this.controlsList[i].ControlValue = this.controlsList[i].ControlValue;
          }
        }
      }
    });
  }

  /**
   * Function to block/unblock user from EAP Registration.
   * If IsBlocked is true, then set RECORD_STATE as 0 (blocked)
   * else set RECORD_STATE as 1 (unblocked)
   * and call updateUser API of EAPRegistration.
   * If API returns success, then show success banner and close modal,
   * else show error banner.
   */
  BlockUser() {
    let formData1 = new Object();
    formData1["ID"] = this.Content.content.id;
    formData1["RECORD_STATE"] = this.IsBlocked == true ? 0 : 1;
    formData1["MODULE"] = this.Content.content.Module;

    this.summaryService.updateUser("api/EAPRegistration/updateUser", formData1).subscribe((result: any) => {
      if ((result.Status == 0)) {
        this.commonService.SuccessBanner("Registration Details updated successfully");
        this.modalRef.close("Yes");
      } else {
        this.commonService.ValidationBanner(result.Message);
      }
    });
  }
}
